import React from "react";
import { IconProps } from "../../components/Icon";

export default function DuplicateOrangeIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "12"}
      height={height || "13.714"}
      viewBox="0 0 12 13.714"
    >
      <path
        id="Caminho_10219"
        data-name="Caminho 10219"
        d="M8.571-2h-4.5a1.5,1.5,0,0,1-1.5-1.5v-7.929H.643A.643.643,0,0,0,0-10.786V-.929a.643.643,0,0,0,.643.643H7.929a.643.643,0,0,0,.643-.643Zm0-9.214V-14h-4.5a.643.643,0,0,0-.643.643V-3.5a.643.643,0,0,0,.643.643h7.286A.643.643,0,0,0,12-3.5v-7.071H9.214A.645.645,0,0,1,8.571-11.214Zm3.24-.831-1.766-1.766A.738.738,0,0,0,9.591-14H9.429v2.571H12v-.162A.739.739,0,0,0,11.812-12.045Z"
        transform="translate(0 14)"
        fill="#fb972e"
      />
    </svg>
  );
}
